<!--
 * @Description: 代缴税金审核弹窗
 * @Date: 2026-03-26 11:27:40
-->

<template>
  <BaseDialog
    width="500px"
    title="审核"
    :model-value="true"
    :show-close="true"
    :close-on-press-escape="true"
    :close-on-click-modal="false"
    :showFooter="false"
  >
    <BaseTextContent>
      <BaseForm
        ref="formRef"
        label-position="right"
        :rules="formRules"
        :model="formData"
      >
        <BaseFormItem label="代缴税金" prop="proxyTaxAmount">
          <BaseInputNumber
            :controls="false"
            :precision="2"
            :min="0.01"
            :max="999999999"
            v-model="formData.proxyTaxAmount"
          >
            <template #append>元</template>
          </BaseInputNumber>
        </BaseFormItem>
        <BaseFormItem label="上传附件" prop="fileList">
          <BaseUpload
            style="margin-bottom: 20px"
            btnText="上传"
            tipText="支持上传 word/xls/xlsx/pdf/.rar/.zip/.7z/jpg/png 文件，且不超过500M"
            autoUpload
            listType="text"
            :accept="[
              '.jpg',
              '.jpeg',
              '.png',
              '.word',
              '.xls',
              '.pdf',
              '.rar',
              '.zip',
              '.7z'
            ]"
            :limit="10"
            :limitSize="500"
            :multiple="false"
            :http-request="uploadApi"
            v-model:fileList="formData.fileList"
            @preview="onPreviewFile"
          ></BaseUpload>
        </BaseFormItem>
      </BaseForm>
    </BaseTextContent>
    <template #footer>
      <BaseButton type="default" @click="remove">取消</BaseButton>
      <BaseButton type="primary" @click="onPass">确认提交</BaseButton>
    </template>
  </BaseDialog>
</template>
<script lang="tsx" setup>
import { ref } from 'vue';
import {
  BaseTextContent,
  BaseForm,
  BaseFormItem,
  BaseDialog,
  BaseButton,
  XrkMessage,
  BaseInputNumber,
  BaseUpload
} from 'xrk-components';
import { proxyTaxFile } from '../../data-source/apis';
import { uploadApi } from '@data-source/common/apis';

const emits = defineEmits(['success']);
const props = withDefaults(
  defineProps<{
    remove?: () => {};
    id: number;
  }>(),
  {}
);

const formRef = ref();
const formData = ref<{ fileList: any; proxyTaxAmount: number }>({
  fileList: [],
  proxyTaxAmount: null
});

const formRules = {
  proxyTaxAmount: [
    {
      required: true,
      trigger: 'change',
      message: '请填写代缴税金',
      validator: (rule, v, callback) => {
        if (v <= 0) {
          return callback(new Error('请输入大于0的金额'));
        }
        callback();
      }
    }
  ],
  fileList: [
    {
      required: true,
      trigger: 'change',
      validator: (rule, v, callback) => {
        if (!v?.length || v.some(item => !item.url)) {
          return callback(new Error('请重新上传资料'));
        }
        callback();
      }
    }
  ]
};

const onPreviewFile = file => {
  if (file.url) {
    window.open(file.url, '_blank');
  }
};
/**
 * @description: 确认提交
 */
const onPass = async () => {
  await formRef.value.validate();
  // 代缴税金单位转换（元→分）统一在数据源层 proxyTaxFile 内处理
  await proxyTaxFile({
    id: props.id,
    proxyTaxAmount: formData.value.proxyTaxAmount,
    fileList: formData.value.fileList
  });
  XrkMessage.success('提交成功');
  emits('success');
  props.remove();
};
</script>
